import { AuthConfig } from 'angular-oauth2-oidc'

import { environment } from '@flowx/designer/environment'

import { FX_SIGN_IN_SOURCE, FX_SIGN_IN_SOURCE_DESIGNER } from './auth.constants'

export function authConfigFactory(): AuthConfig {
  const authConfig: AuthConfig = {
    responseType: environment.keycloak.responseType,
    // set the scope for the permissions the client should request
    // The first three are defined by OIDC.
    scope: environment.keycloak.scope,
    // Remove the requirement of using Https to simplify the demo
    // THIS SHOULD NOT BE USED IN PRODUCTION
    // USE A CERTIFICATE FOR YOUR IDP
    // IN PRODUCTION
    requireHttps: environment.keycloak.requireHttps === 'true',
    // at_hash is not present in JWT token
    showDebugInformation: environment.keycloak.showDebugInformation === 'true',
    disableAtHashCheck: environment.keycloak.disableAtHashCheck === 'true',

    skipIssuerCheck: environment.skipIssuerCheck === 'true',
    strictDiscoveryDocumentValidation: environment.strictDiscoveryDocumentValidation === 'true',
    customQueryParams: { [FX_SIGN_IN_SOURCE]: FX_SIGN_IN_SOURCE_DESIGNER },
  }
  return authConfig
}

export class OAuthModuleConfig {
  resourceServer: OAuthResourceServerConfig = {
    sendAccessToken: true,
    allowedUrls: [`${environment.baseUrl}`],
  }
}

export class OAuthResourceServerConfig {
  /**
   * Urls for which calls should be intercepted.
   * If there is an ResourceServerErrorHandler registered, it is used for them.
   * If sendAccessToken is set to true, the access_token is send to them too.
   */
  allowedUrls?: Array<string>
  sendAccessToken = true
  customUrlValidation?: (url: string) => boolean
}
